import "./styles/notfound.css";
import logo from "../images/Round-logo.webp";
import { Link } from "react-router-dom";
import Nav from "./Nav";

export default function NotFound() {
    return (
            <>
             <Nav />
        <section className="pageNot">
           
            <div className="notfound-bg">
                <div className="bg-pink"></div>
                <div className="bg-teal"></div>
                <div className="bg-dot dot-one"></div>
                <div className="bg-dot dot-two"></div>
                <div className="bg-dot dot-three"></div>
            </div>

            <div className="notfound-card">

                <div className="notfound-top">
                    <img
                        src={logo}
                        alt="Tubbees"
                        className="logoTop"
                    />

                    <span className="error-label">
                        ERROR 404
                    </span>
                </div>

                <div className="notfound-main">

                    <div className="notfound-number">
                        <span>4</span>

                        <div className="zero">
                            <div className="zero-inner"></div>
                        </div>

                        <span>4</span>
                    </div>

                    <h2>
                        Oh no! Page not found!
                    </h2>

                    <p>
                        Try going to{" "}
                        <Link to="/">
                            Tubbees Home Page
                        </Link>
                    </p>

                    <Link
                        to="/"
                        className="home-button"
                    >
                        <span>GO HOME</span>

                        <b className="arrow-icon">
                            <svg
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                            >
                                <path
                                    d="M5 12h13M13 6l6 6-6 6"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </b>
                    </Link>

                </div>

                <div className="notfound-footer">
                    <span>TUBBEES</span>
                    <span>YOUR WORLD OF FLAVOUR</span>
                </div>

            </div>

        </section>
        </>
    );
}